"use client";

// Pruebas A/B: lo que hay que hacer en cada cambio de página. No dibuja nada.
//
// El sorteo de la primera página lo hace el script inline del <head> (lib/ab/script.js), antes
// de que exista este componente. Acá van las dos cosas que ese script no puede hacer:
//
//  - Sortear cuando se llega a una página navegando SIN recargar (un <Link> de Next): el
//    script del head no vuelve a correr. Va en un efecto de layout, que corre antes de que el
//    navegador dibuje la página nueva, para que la variante no parpadee.
//  - Avisarle al servidor que el visitante entró a una prueba o abrió el checkout. Eso va en
//    un efecto común, después del dibujo: es un aviso y no puede demorar nada.
//
// Las dos llamadas son seguras de repetir: sortear lo que ya está sorteado no hace nada, y el
// aviso se manda una sola vez por sesión (LocaleUrlSync corrige /libros a /es/libros, y eso
// vuelve a disparar los efectos).

import { useEffect, useLayoutEffect } from "react";
import { usePathname } from "next/navigation";
import { anotarRuta, asignarRuta } from "@/lib/ab";

export default function PruebasAb() {
  const pathname = usePathname();

  useLayoutEffect(() => {
    asignarRuta(pathname);
  }, [pathname]);

  useEffect(() => {
    anotarRuta(pathname);
  }, [pathname]);

  return null;
}
